export type HandicapFields = {
  handicap?: number;
  handicapIndex?: number;
  courseHandicap?: number | null;
  courseHandicapCourse?: string | null;
  courseHandicapTee?: string | null;
};

export function resolveHandicapIndex(fields: HandicapFields) {
  const value = fields.handicapIndex ?? fields.handicap ?? 0;
  return Number(value);
}

export function formatHandicapIndex(value: number) {
  return Number(value).toFixed(1);
}

export function formatCourseHandicap(value: number | null | undefined) {
  if (value == null) {
    return '—';
  }
  return String(value);
}

export function courseHandicapLabel(fields: HandicapFields) {
  if (fields.courseHandicap == null) {
    return null;
  }
  const course = fields.courseHandicapCourse?.trim();
  const tee = fields.courseHandicapTee?.trim();
  if (course && tee) {
    return `${course} · ${tee}`;
  }
  return course ?? tee ?? null;
}
